/*
  Upsell du tiroir de panier.
  Le bloc est rendu par snippets/cart-drawer.liquid, donc il est recalcule cote
  serveur a chaque changement de panier : le produit propose n'est jamais un
  produit deja dans le panier. Le custom element se re-attache tout seul apres
  chaque remplacement d'innerHTML (les <script> inline, eux, ne rejoueraient pas).
*/
class DdfCartUpsell extends HTMLElement {
  connectedCallback() {
    const btn = this.querySelector('.cart_upsell-add');
    if (!btn || btn.dataset.ddfBound) return;
    btn.dataset.ddfBound = '1';
    btn.addEventListener('click', () => this.add(btn));
  }

  async add(btn) {
    if (btn.disabled) return;
    const label = btn.textContent;
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.textContent = 'Adding...';

    const drawer = document.querySelector('cart-drawer');
    const errors = document.getElementById('CartDrawer-CartErrors');
    if (errors) errors.textContent = '';

    const body = new FormData();
    body.append('id', btn.dataset.variantId);
    body.append('quantity', '1');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.append('sections', drawer.getSectionsToRender().map((s) => s.id).join(','));
      body.append('sections_url', window.location.pathname);
    }

    const url = (window.routes && window.routes.cart_add_url) || '/cart/add';

    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      });
      const data = await res.json();
      if (data.status) throw new Error(data.description || data.message || 'add failed');

      if (drawer && data.sections) {
        drawer.renderContents(data);
      } else {
        window.location.reload();
      }
    } catch (e) {
      btn.textContent = label;
      btn.disabled = false;
      btn.classList.remove('is-loading');
      if (errors) errors.textContent = "Sorry, we couldn't add this item. Please try again.";
    }
  }
}

customElements.define('ddf-cart-upsell', DdfCartUpsell);
